import { useTranslation } from "react-i18next";
import { NeuButton } from "../../components/neu/Neu";

const TONES = ["upbeat", "energetic", "calm"];

// اختيار نبرة التحية: متفائل / متحمّس / هادئ — تُغيّر أيضاً السرعة المقترحة.
export const ToneSelect = ({ value, onChange }) => {
  const { t } = useTranslation();
  return (
    <div className="mt-3 flex flex-wrap items-center gap-2">
      <span className="text-[11px] text-muted-foreground">{t("greeting.tone")}</span>
      {TONES.map((tone) => (
        <NeuButton
          key={tone}
          type="button"
          variant={value === tone ? "primary" : undefined}
          className="px-3 py-2 text-[11px]"
          data-testid={`voice-tone-${tone}`}
          onClick={() => onChange(tone)}
        >
          {t(`greeting.tones.${tone}`)}
        </NeuButton>
      ))}
    </div>
  );
};
